import { render, staticRenderFns } from "./PatientMatchingPopup.vue?vue&type=template&id=70237e2c&scoped=true&"
import script from "./PatientMatchingPopup.vue?vue&type=script&lang=js&"
export * from "./PatientMatchingPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70237e2c",
  null
  
)

export default component.exports